module.exports = "<span ng-bind=\"vm.matchValue\"></span>%\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/interestMatch/interestMatch.html
// module id = 122
// module chunks = 0 1